var map = {
	"./2350_MU4.jpg": 6165,
	"./2350_MU4.png": 5189,
	"./MN2.jpg": 2967,
	"./MN2.png": 7719,
	"./header__bg.png": 4132,
	"./product_1.jpg": 527,
	"./product_2.jpg": 6912,
	"./product_3.jpg": 8045,
	"./product_4.jpg": 6934,
	"./product_5.jpg": 3395,
	"./product_6.jpg": 5588,
	"./products__bg.jpg": 7667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4634;